<template>
  <div class="footer col-block width-full">
    <div class="footer-container col-block width-full">
      <div :style="{ height: ['mobile'].includes(windowType) ? '20px' : '30px' }"></div>
      <div class="footer-main-container" :class="[['mobile'].includes(windowType) ? 'col-block width-full' : 'row-block flex-start']">
        <div class="footer-info-container col-block" :class="[['mobile'].includes(windowType) ? 'width-full' : 'flex-start']" :style="{ flex: 2 }">
          <div class="footer-info-logo-container center-block">
            <img :src="require('@/assets/images/compass-white-logo.svg')" alt="" :style="{ 'max-width': '138.5px' }">
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="footer-info-data-container col-block flex-start">
            <div class="footer-info-data-block row-block flex-start" v-for="(infoData, idindex) in infoDatas" :key="idindex">
              <div class="footer-info-data-title break-line">{{ infoData.title }}</div>
              <div class="footer-info-data-content-container shrink col-block flex-start">
                <div class="footer-info-data-content break-line" v-for="(infoContent, icindex) in infoData.contents" :key="icindex">{{ infoContent }}</div>
              </div>
            </div>
          </div>
        </div>
        <div :style="['mobile'].includes(windowType) ? { height: '0px' } : { width: '40px' }"></div>
        <div class="footer-certification-container col-block flex-start" :style="{ flex: 1 }">
          <div v-if="false" class="footer-certification-block flex-start" :class="[['mobile'].includes(windowType) ? 'row-block' : 'col-block']">
            <div class="footer-certification-title">{{ 'ISO13485認証'/* ___ */ }}</div>
            <div :style="['mobile'].includes(windowType) ? { width: '30px' } : { height: '10px' }"></div>
            <img :src="require('@/assets/images/bsi-certification-logo.svg')" alt="">
          </div>
        </div>
      </div>
      <div :style="{ height: '40px' }"></div>
      <div class="footer-copyright-container col-block">
        <div class="footer-copyright">{{ copyrightData.text }}</div>
      </div>
      <div :style="{ height: '25px' }"></div>
    </div>
  </div>
</template>

<script>
import responsitiveData from '@/mixins/responsitiveData.vue'
import { compassEmail } from '@/constants/global/data'

export default {
  mixins: [
    responsitiveData
  ],
  computed: {
    infoDatas () {
      return [
        {
          title: '住　所'/* ___ */,
          contents: [
            '東京都港区西新橋一丁目6番12号アイオス虎ノ門803室'
          ]
        },
        {
          title: 'メール'/* ___ */,
          contents: [
            compassEmail
          ]
        }
      ]
    },
    copyrightData () {
      return {
        text: 'Copyright © ' + (new Date()).getFullYear() + ' All Rights Reserved'/* ___ */
      }
    }
  }
}
</script>
